import React from 'react';
import { auth } from '../services/firebase.js';
import { signOut } from 'firebase/auth';

export default function Sidebar({ activeTab, onTabChange, courierName, userName, userRole }) {
  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'stamps', label: 'Stamps', icon: '🔮' },
    { id: 'stats', label: 'Statistics', icon: '📈' },
    { id: 'billing', label: 'Billing', icon: '💳' },
    { id: 'api-keys', label: 'API Keys', icon: '🔑' },
    { id: 'profile', label: 'Profile', icon: '👤' },
    { id: 'security', label: 'Security', icon: '🔒' },
  ];

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      window.location.href = '/login';
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <div className="sidebar">
      <div className="logo">
        <div className="logo-icon">📦</div>
        <span>Digital Postage System</span>
      </div>

      <div className="courier-info">
        <div className="courier-info-label">Courier</div>
        <div className="courier-info-name">{courierName || 'Loading...'}</div>
      </div>

      <div className="nav">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="nav-item-icon">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="user-section">
        <div className="user-avatar">{getInitials(userName)}</div>
        <div>
          <div className="user-name">{userName || 'User'}</div>
          <div className="user-role">{userRole || 'Admin'}</div>
        </div>
        <button 
          onClick={handleSignOut}
          style={{
            marginLeft: 'auto',
            background: 'transparent',
            border: 'none',
            color: 'var(--text-secondary)',
            cursor: 'pointer',
            fontSize: '12px',
            padding: '4px 8px'
          }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}